import * as React from 'react';
import styled from 'styled-components';
import { getFullIconsName } from '../../constants/iconsName';
import Footer from '../footer/Footer';
import common from '../../constants/common';

// ############################ Styles ###########################
// tslint:disable:variable-name
const SLandingPageLayout = styled.main<{
  leftUpperImage: string;
  rightUpperImage: string;
  coverAllScreen: boolean;
}>(({ theme, leftUpperImage, rightUpperImage, coverAllScreen }) => {
  return `
  display: flex;
  justify-content: center;
  align-self: stretch;
  box-sizing: border-box;
  padding: ${theme.spacing.larger2 + 10}px ${theme.spacing.huge}px ;
  position: relative;
  background-color: ${theme.colors.homeBackground};
  height: ${coverAllScreen ? '100vh' : '531px'};
  overflow: hidden;
  scroll: none;

  @media only screen and ${theme.device.max.laptopS} {
    height: ${coverAllScreen ? '100vh' : '694px'};
  }

  @media only screen and ${theme.device.max.mobileM} {
    height: ${coverAllScreen ? '100vh' : '600px'};
  }

  &:before {
    content: '';
    background-image: url(${leftUpperImage});
    background-repeat: no-repeat;
    position: absolute;
    z-index: 99;
    top: 69px;
    left: 0;
    width: 100%;
    height: 308px;

    @media only screen and ${theme.device.max.laptopMS} {
      left: -35px;
    }

    @media only screen and ${theme.device.max.laptopS} {
      left: -50px;
      top: 360px;
      ${coverAllScreen ? 'display: none;' : ''};
    }

    @media only screen and ${theme.device.max.mobileM} {
      left: -60px;
      top: 311px;
    }
  }

  &:after {
    content: '';
    background-image: url(${rightUpperImage});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    border-radius: 50%;
    z-index: 99;
    top: 106px;
    right: 60px;
    width: 266.5px;
    height: 266.5px;

    @media only screen and ${theme.device.max.laptop} {
      right: 30px;
      width: 230.5px;
      height: 230.5px;
    }

    @media only screen and ${theme.device.max.laptopMS} {
      right: 20px;
      width: 180.5px;
      height: 180.5px;
    }

    @media only screen and ${theme.device.max.laptopS} {
      right: 20px;
      width: 233px;
      height: 233px;
      top: 387px;
      ${coverAllScreen ? 'display: none;' : ''};
    }

    @media only screen and ${theme.device.max.mobileM} {
      width: 150px;
      height: 150px;

    }
  }
  `;
});

const SLandingPageBackgroundImg = styled.div<{
  leftBottomImage: string;
  coverAllScreen: boolean;
}>(({ theme, leftBottomImage, coverAllScreen }) => {
  return `
    background-image: url(${leftBottomImage});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    z-index: 999;
    border-radius: 50%;
    top: ${coverAllScreen ? '363px' : '370px'};
    left: 50px;
    width: 209px;
    height: 209px;

    @media only screen and ${theme.device.max.laptopMS} {
      width: 180px;
      height: 180px;
    }

    @media only screen and ${theme.device.max.laptopS} {
      display: none;
    }
    
  
    `;
});

const SLandingPageBackgroundImg2 = styled.div<{
  rightBottomImage: string;
  coverAllScreen: boolean;
}>(({ theme, rightBottomImage, coverAllScreen }) => {
  return `
    background-image: url(${rightBottomImage});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    position: absolute;
    z-index: 8;
    border-radius: 0px;
    transform: scale(2);
    top: 182px;
    right: -142px;
    width: 302px;
    height: 502px;

    @media only screen and ${theme.device.max.laptop} {
      transform: scale(1.5);
      top: 121px;
      right: -140px;
    }

    @media only screen and ${theme.device.max.laptopMS} {
      transform: scale(1);
      top: 60px;
      right: -120px;
    }

    @media only screen and ${theme.device.max.laptopS} {
      transform: scale(1.5);
      top: 405px;
      right: -147px;
      ${coverAllScreen ? 'display: none;' : ''};
    }

    @media only screen and ${theme.device.max.mobileM} {
      transform: scale(1);
      top: 313px;
    }
    `;
});
const SLandingPageContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
`;

// tslint:enable:variable-name
// ############################ End Styles ###########################

export interface ILandingPageProps {
  iconsGroupName: string;
  coverAllScreen: boolean;
  children: React.ReactNode;
  footer?: boolean;
}

export default ({ iconsGroupName, coverAllScreen, children, footer = false }: ILandingPageProps) => {
  const { leftUpperImage, rightUpperImage, leftBottomImage, rightBottomImage } = getFullIconsName[iconsGroupName];

  return (
    <SLandingPageLayout
      coverAllScreen={coverAllScreen}
      leftUpperImage={leftUpperImage}
      rightUpperImage={rightUpperImage}
    >
      <SLandingPageBackgroundImg coverAllScreen={coverAllScreen} leftBottomImage={leftBottomImage} />
      <SLandingPageBackgroundImg2 coverAllScreen={coverAllScreen} rightBottomImage={rightBottomImage} />
      <SLandingPageContentWrapper>
        {children}

        {footer && <Footer {...common.sunbitDetails.partnersPortal} dataAt={'footerSunbitPartnersPortalLogIn1'} />}
      </SLandingPageContentWrapper>
    </SLandingPageLayout>
  );
};
